package com.nonopn.skywatcher.design.widgets

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.Text
import androidx.compose.material.TopAppBar
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.Menu
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.design.appbar.AppBarStateProvider
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.theme.AppColor
import eu.codlab.compose.widgets.spacers.TopSpacer

@Composable
fun TopAppBarExtended(
    title: String,
    topSpacer: Boolean,
    canGoBack: Boolean,
    isScreenExpanded: Boolean,
    appModel: AppBarStateProvider,
    painter: Painter? = null,
    onNavigationClick: () -> Unit
) {
    val modelState by appModel.states.collectAsState()
    val appBarState = modelState.appBarState

    val menu = when {
        canGoBack -> Icons.AutoMirrored.Filled.ArrowBack
        !isScreenExpanded -> Icons.Filled.Menu
        else -> null
    }

    val tint = AppColor.StrikeSidebar
    val bgColor = AppColor.White

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        if (topSpacer) {
            TopSpacer(bgColor)
        }

        if (painter != null) {
            // Custom tall logo bar — 2x the previous height
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(128.dp)
                    .background(bgColor)
                    .padding(horizontal = 4.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                if (menu != null) {
                    IconButton(onClick = onNavigationClick) {
                        Icon(
                            modifier = Modifier.size(28.dp),
                            imageVector = menu,
                            contentDescription = null,
                            tint = tint
                        )
                    }
                }
                Image(
                    modifier = Modifier.height(112.dp),
                    painter = painter,
                    contentDescription = "Strike Radar", // ⚠️ hardcoded string — needs stringResource
                    contentScale = ContentScale.Fit
                )
                Spacer(modifier = Modifier.weight(1f))
                appBarState.actions?.forEach {
                    it.Draw(this, tint)
                }
            }
        } else {
            TopAppBar(
                elevation = 4.dp,
                title = {
                    Text(
                        fontSize = LocalFontSizes.current.actionBar.title,
                        text = title,
                        color = tint
                    )
                },
                backgroundColor = bgColor,
                navigationIcon = if (null != menu) {
                    {
                        IconButton(onClick = onNavigationClick) {
                            Icon(menu, null, tint = tint)
                        }
                    }
                } else {
                    null
                },
                actions = {
                    appBarState.actions?.forEach {
                        it.Draw(this, tint)
                    }
                }
            )
        }
    }
}
